import React from 'react';
import './UISpinner.scss';

export interface UISpinnerProps {
  /**
   * Розмір спінера
   */
  size?: 'small' | 'medium' | 'large';
}

const UISpinner: React.FC<UISpinnerProps> = ({ size = 'medium' }) => {
  const spinnerClasses = [
    'UISpinner',
    size && `UISpinner--${size}`,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={spinnerClasses} />;
};

export default UISpinner;
